import { render } from "./phoneNumber.vue?vue&type=template&id=2044274c&scoped=true"
import script from "./phoneNumber.vue?vue&type=script&lang=js"
export * from "./phoneNumber.vue?vue&type=script&lang=js"

import "./phoneNumber.vue?vue&type=style&index=0&id=2044274c&lang=scss&scoped=true"

import exportComponent from "/usr/src/test-oho-sales/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2044274c"]])

export default __exports__